import styled from 'styled-components';
import IconButtonProps from './type';

const IconButtonStyled = styled.button<IconButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  cursor: pointer;
  padding: ${(props) => {
    switch (props.size) {
      case 'large':
        return '13px';
      case 'medium':
        return '10px';
      default:
        return '11px';
    }
  }};
  width: ${(props) => {
    switch (props.size) {
      case 'large':
        return '56px';
      case 'medium':
        return '24px';
      default:
        return '40px';
    }
  }};
  height: ${(props) => {
    switch (props.size) {
      case 'large':
        return '56px';
      case 'medium':
        return '24px';
      default:
        return '40px';
    }
  }};

  ${(props) => {
    switch (props.variant) {
      case 'ghost':
        return `
            background-color: transparent;
            border: 1px solid transparent;
            box-shadow: none;
        `;
      default:
        return `
            background-color: #E3EDF7;
            border: 1px solid #E3EDF7;
            box-shadow: 4px 4px 20px 0px #6f8cb068, -6px -6px 20px 0px #FFF, 2px 2px 4px 0px #728eab19;

            &:active {
                border: 1px solid ${props.theme.colors.gray100};
                background-color: ${props.theme.colors.gray100};
                box-shadow: 4px 4px 14px 0px #D9D9D9 inset, -4px -4px 9px 0px rgba(255, 255, 255, 0.88) inset;
            }
        `;
    }
  }};
`;

export default IconButtonStyled;
